import React from "react";
import { Card, Container, Row, Col } from "react-bootstrap";

const Projects = () => {
  const projects = [
    {
      title: "CNR International - Ninian Northern Jacket Removal (2022)",
      role: "Technical Lead",
      scope:
        "Engineering, preparation, and offshore removal of the 14,500-tonne jacket using Allseas’ Pioneering Spirit Jacket Lift System.",
      impact:
        "Ground-breaking North Sea decommissioning milestone completed safely and on budget.",
      imageUrl: "/Project1.jpg",
      
    },
    {
      title:
        "Spirit Energy: DP3 & DP4 Decommissioning, East Irish Sea (2018 - 2020)",
      role: "Decommissioning Project Engineer",
      scope:
        "Pipeline flushing, well P&A, topside clean-down, and subsea recovery operations.",
      impact:
        "Safe and environmentally responsible removal of redundant assets.",
      imageUrl: "/Project2.jpg",
      photoCredit: "",
    },
    {
      title: "Maersk Oil – Gryphon Area Reconstruct Project (2012 - 2013)",
      role: "Senior Subsea Installation Engineer / Client Technical Rep",
      scope:
        "Management of diving, riser installation, and subsea infrastructure rebuild on one of the largest offshore construction projects in the North Sea.",
      impact:
        "Successful reinstatement of field production through safe and efficient subsea reconstruction.",
      imageUrl: "/Project3.jpg",
      photoCredit: "",
    },
  ];

  return (
    <Container className="my-5">
      <h2 className="title mb-4 text-left">Projects</h2>
      <Row>
        {projects.map((project, index) => (
          <Col key={index} xs={12} sm={6} lg={4} className="mb-4">
            <Card className="h-100 shadow-sm">
              <div style={{ position: "relative" }}>
                <Card.Img
                  variant="top"
                  src={project.imageUrl}
                  alt={project.title}
                  style={{ width: "100%", height: "auto" }}
                />
                <span
                  style={{
                    position: "absolute",
                    bottom: "5px",
                    right: "5px",
                    fontSize: "0.7rem",
                    color: "white",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    padding: "2px 5px",
                    borderRadius: "3px",
                  }}
                  className="photo-credit"
                >
                  {project.photoCredit}
                </span>
              </div>
              <Card.Body>
                <Card.Title className="fw-bold mb-3">
                  {project.title}
                </Card.Title>
                <Card.Text>
                  <strong>Role:</strong> {project.role} <br />
                  <strong>Scope:</strong> {project.scope} <br />
                  <strong>Impact:</strong> {project.impact}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Optional: Responsive font-size for photo credit */}
      <style jsx>{`
        @media (max-width: 576px) {
          .photo-credit {
            font-size: 0.55rem !important;
            padding: 1px 3px !important;
          }
        }
      `}</style>
    </Container>
  );
};

export default Projects;
